module.exports = __webpack_public_path__ + "static/about-bg-mobile-f89c071c1e0964291bba8de245539a06.png";